import { useGetAllAssignedUserProgressQuery } from '../../../../__generated__/chirp/com/hubspot/learning/center/credentials/rpc/AssignedContentChirpService.hooks';
import { DEFAULT_PAGE_SIZE } from '../constants/pagination';
import I18n from 'I18n';
export const useRecentlyCompletedAssignedContent = () => {
  const {
    data,
    loading,
    error
  } = useGetAllAssignedUserProgressQuery({
    variables: {
      sortOrder: 'DESC',
      sortField: 'COMPLETED_DATE',
      offset: {
        offsetPosition: 0
      },
      pageLength: 25,
      status: 'COMPLETED'
    }
  });
  return {
    recentlyCompletedAssignedContent: data === null || data === void 0 ? void 0 : data.results,
    recentlyCompletedAssignedContentLoading: loading,
    recentlyCompletedAssignedContentError: error
  };
};
export const useIncompleteAssignedContent = () => {
  const today = I18n.moment.userTz().startOf('day');
  const tenYearsAgo = I18n.moment.userTz().startOf('day').subtract(10, 'years');
  const {
    data,
    loading,
    error
  } = useGetAllAssignedUserProgressQuery({
    variables: {
      sortOrder: 'DESC',
      sortField: 'DUE_DATE',
      offset: {
        offsetPosition: 0
      },
      pageLength: 25,
      status: 'INCOMPLETE',
      dueDate: {
        startDate: tenYearsAgo.valueOf(),
        endDate: today.valueOf()
      }
    }
  });
  return {
    incompleteAssignedContent: data === null || data === void 0 ? void 0 : data.results,
    incompleteAssignedContentLoading: loading,
    incompleteAssignedContentError: error
  };
};
export const useAssignedContentProgress = ({
  pageLength = DEFAULT_PAGE_SIZE,
  offset = 0,
  sortOrder = 'ASC',
  sortField = 'CONTENT_NAME',
  contentNameQuery,
  teams,
  users,
  contentIds,
  contentTypes,
  status,
  assignedBy,
  dueDate,
  completedAt
}) => {
  const {
    data,
    loading,
    error,
    previousData
  } = useGetAllAssignedUserProgressQuery({
    variables: Object.assign({
      sortOrder,
      sortField
    }, contentNameQuery ? {
      contentNameQuery
    } : {}, teams && teams.length > 0 ? {
      teams
    } : {}, users && users.length > 0 ? {
      teamMembers: users
    } : {}, contentIds && contentIds.length > 0 ? {
      contentIds
    } : {}, contentTypes && contentTypes.length > 0 ? {
      contentTypes
    } : {}, {
      offset: {
        offsetPosition: offset
      },
      pageLength
    }, status ? {
      status
    } : {}, assignedBy !== undefined ? {
      assignedBy
    } : {}, dueDate ? {
      dueDate
    } : {}, completedAt ? {
      completedAt
    } : {})
  });
  return {
    assignedContentProgress: data,
    assignedContentProgressLoading: loading,
    assignedContentProgressError: error,
    previousData
  };
};